<template>
<div class="growthBookEvaluationtemplatedetails"  >
     <div class="top"> 
        <el-col :span="8">
          <el-button @click="$router.go(-1)" type="default" size="medium">返回</el-button> 
         <el-button type="primary" size="medium" class="left-line" v-if="enable==0" @click="enableAssessTemplates(1)">启用</el-button>
         <el-button type="primary" size="medium" class="left-line" v-if="enable==1" @click="enableAssessTemplates(0)">关闭</el-button>
         <el-button type="primary" size="medium" class="left-line"  v-if="enable==0" @click="addfuntwo()">新增领域</el-button>
        </el-col>
        <el-col :span="8">
          <div class="title">{{title}}</div>
        </el-col>
            
      </div>
     <div class="subject" :style="`height: ${maxH+10}px;`" v-loading.body="listLoading">
          <div class="left">
             <div class="ul">
                 <div class="li" @click="myindexsfun(index)" :class="{'color':index==myindexs}" :key="index" v-for="(item,index) in domainList">
                     {{item.domainName}}
                     <i class="el-icon-delete" v-if="enable==0" style="color:#F56C6C"  @click.stop="deleteAssessTemplateDomainById(item.id)"></i>
                     <i class="el-icon-edit" v-if="enable==0" @click.stop="eidtfuntwo(item)"></i>
                 </div>
             </div>
         </div>
         <div class="body">   
             <div class="body-top" v-if="enable==0">              
                 <el-button type="primary"  class="left-line" @click="addfun()"  size="mini">添加评估标准</el-button> 
            </div>          
           <el-table stripe  :data="domainList[myindexs].questionList" border fit highlight-current-row  style="width: 100%" :height="maxH-myheigth">
            <el-table-column  label="题号" align="center" show-overflow-tooltip  width="60">
                <template slot-scope="scope">{{scope.row.questionNo}}</template>
            </el-table-column>
            <el-table-column  label="发展评估标准" show-overflow-tooltip >
                <template slot-scope="scope">{{scope.row.question}}</template>
            </el-table-column>           
            <el-table-column align="center" label="操作" width="150" v-if="enable==0">
                <template slot-scope="scope">
                    <el-button size="small"  v-if="enable==0" type="text"  @click.native="eidtfun(scope.row)">编辑 </el-button>
                    <el-button size="small"  v-if="enable==0" type="text"  @click.native="deleteAssessTemplateQuestionByIds(scope.row.id)" >删除</el-button>
                </template>
            </el-table-column>
        </el-table>
        <el-dialog :title="ruleForm.name" :close-on-press-escape='false' :close-on-click-modal='false' :visible.sync="dialogVisible" width="700px" :lock-scroll="false" :modal-append-to-body='false'>
			  <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="140px" class="demo-ruleForm">
          <el-form-item label="发展评估标准" prop="question" >
            <el-input v-model.trim="ruleForm.question" placeholder="请输入发展评估标准" size="medium" :maxlength="60"></el-input>
          </el-form-item> 
          <el-form-item label="题号" prop="questionNo" >
            <el-input-number v-model.trim="ruleForm.questionNo"  :min="1" ></el-input-number>
          </el-form-item>         
        </el-form>
			<span slot="footer" class="dialog-footer">
				<el-button @click="dialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="insertAssessTemplateQuestions('ruleForm')">确 定</el-button>
			</span>
		</el-dialog>

         <el-dialog :title="ruleFormtwo.name" :close-on-press-escape='false' :close-on-click-modal='false' :visible.sync="dialogVisibletwo" width="700px" :lock-scroll="false" :modal-append-to-body='false'>
			  <el-form :model="ruleFormtwo" :rules="rulestwo" ref="ruleFormtwo" label-width="140px" class="demo-ruleForm">
          <el-form-item label="领域名称" prop="domainName" >
            <el-input v-model.trim="ruleFormtwo.domainName" placeholder="请输入领域名称" size="medium" :maxlength="6"></el-input>
          </el-form-item> 
          <el-form-item label="排序" prop="orderNo" >
            <el-input-number v-model.trim="ruleFormtwo.orderNo"  :min="1" ></el-input-number>
          </el-form-item>         
        </el-form>
			<span slot="footer" class="dialog-footer">
				<el-button @click="dialogVisibletwo = false">取 消</el-button>
				<el-button type="primary" @click="insertAssessTemplateDomain('ruleFormtwo')">确 定</el-button>
			</span>
		</el-dialog>

         </div>
      
     </div>
</div> 
</template>
<script>
import {
  getAssessTemplateById,
  enableAssessTemplate,
  insertAssessTemplateQuestion,
  editAssessTemplateQuestion,
  deleteAssessTemplateQuestionById,deleteAssessTemplateDomainById,insertAssessTemplateDomain,editAssessTemplateDomain
} from "@/api/growthfootprint";
import mixin from "@/mixins/windowResize";
export default {
  data() {
    return {
      title: "",
      domainList: [],
      id: this.$route.query.id,
      enable: 3,
      myindexs: 0,
      myheigth: 50,
      ruleForm: {
        assessTempId: this.$route.query.id,
        domainId: 0,
        question: "",
        questionNo: 1,
        id: 0,
        name: ""
      },
      dialogVisible: false,
      rules: {
        question: [
          { required: true, message: "请输入发展评估标准", trigger: "blur" }
        ],
        questionNo: [
          { required: true, message: "请输入题号", trigger: "change" }
        ]
      },
       ruleFormtwo: {
        assessTempId: this.$route.query.id,
        domainName: "",
        orderNo: 1,
        id: 0,
        name: ""
      },
     rulestwo: {
        domainName: [
          { required: true, message: "请输入领域名称", trigger: "blur" }
        ],
        orderNo: [
          { required: true, message: "请输入排序", trigger: "change" }
        ]
      },
      listLoading:false,
      mydataname:'',
      level:'',
      levelName:'',
      term:'',
      dialogVisibletwo:false
    };
  },
  mixins: [mixin],
  created() {
    this.getAssessTemplateByIds();
  },
  methods: {
    addfun() {
      this.ruleForm.id = 0;
      this.ruleForm.questionNo = 1;
      this.ruleForm.question = "";
      this.ruleForm.name = "新增发展评估标准";
      this.dialogVisible = true;
    },    
    eidtfun(obj) {
      this.ruleForm.id = obj.id;
      this.ruleForm.questionNo = obj.questionNo;
      this.ruleForm.question = obj.question;
      this.ruleForm.name = "编辑发展评估标准";
      this.dialogVisible = true;
    },
     addfuntwo() {
      this.ruleFormtwo.id = 0;
      this.ruleFormtwo.orderNo = 1;
      this.ruleFormtwo.domainName = "";
      this.ruleFormtwo.name = "新增领域";
      this.dialogVisibletwo = true;
    },
    
    eidtfuntwo(obj) {
      this.ruleFormtwo.id = obj.id;
      this.ruleFormtwo.orderNo = obj.orderNo;
      this.ruleFormtwo.domainName = obj.domainName;
      this.ruleFormtwo.name = "编辑领域";
      this.dialogVisibletwo = true;
    },
    deleteAssessTemplateDomainById(id) {
      this.$confirm("是否删除领域", "删除", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        deleteAssessTemplateDomainById(id)
          .then(res => res.data)
          .then(data => {
            if (data.result) {
              this.$message({ type: "success", message: "删除成功!" });
              this.myindexs=0;
              this.getAssessTemplateByIds();
            }
          });
      });
    },
    //删除
    deleteAssessTemplateQuestionByIds(id) {
      this.$confirm("是否删除", "删除", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        deleteAssessTemplateQuestionById(id)
          .then(res => res.data)
          .then(data => {
            if (data.result) {
              this.$message({ type: "success", message: "删除成功!" });
              this.getAssessTemplateByIds();
            }
          });
      });
    },
    insertAssessTemplateQuestions(formName) {
      this.ruleForm.domainId = this.domainList[this.myindexs].id;
      this.$refs[formName].validate(valid => {
        if (valid) {
          if (this.ruleForm.id == 0) {
            insertAssessTemplateQuestion(this.ruleForm)
              .then(res => {
                if (res.data.code === 200) {
                  this.$message({
                    type: "success",
                    message: "新建成功!"
                  });
                }
                this.dialogVisible = false;
                this.getAssessTemplateByIds();
              })
              .catch(err => {});
          } else {
            editAssessTemplateQuestion(this.ruleForm)
              .then(res => {
                if (res.data.code === 200) {
                  this.$message({
                    type: "success",
                    message: "编辑成功!"
                  });
                }
                this.dialogVisible = false;
                this.getAssessTemplateByIds();
              })
              .catch(err => {});
          }
        }
      });
    },

    insertAssessTemplateDomain(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          if (this.ruleFormtwo.id == 0) {
            insertAssessTemplateDomain(this.ruleFormtwo)
              .then(res => {
                if (res.data.code === 200) {
                  this.$message({
                    type: "success",
                    message: "新增领域成功!"
                  });
                }
                this.dialogVisibletwo = false;
                this.getAssessTemplateByIds();
              })
              .catch(err => {});
          } else {
            editAssessTemplateDomain(this.ruleFormtwo)
              .then(res => {
                if (res.data.code === 200) {
                  this.$message({
                    type: "success",
                    message: "编辑领域成功!"
                  });
                }
                this.dialogVisibletwo = false;
                this.getAssessTemplateByIds();
              })
              .catch(err => {});
          }
        }
      });
    },
    getAssessTemplateByIds() {
      getAssessTemplateById(this.id)
        .then(res => res.data)
        .then(data => {
          let mydata = data.data;
          this.title = mydata.title;
          this.domainList = mydata.domainList;
          this.enable = mydata.enable;
          this.level= mydata.level;
          this.levelName= mydata.levelName;
          this.term= mydata.term;
          if (this.enable == 1) {
            this.myheigth = 12;
          }
        });
    },
    enableAssessTemplates(num) {      
      let name = num == 0 ? "关闭" : "启用";
      this.$confirm("是否" + name, name, {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        enableAssessTemplate(num, this.id,this.level,this.levelName,this.term)
          .then(res => res.data)
          .then(data => {
            if (data.result) {
              this.$message({ type: "success", message: name + "成功!" });
              this.getAssessTemplateByIds();
            }
          });
      });
    },
    //切换领域
    myindexsfun(index) {
      this.myindexs = index;
    }
  }
};
</script>
<style lang="scss" scoped>
.growthBookEvaluationtemplatedetails {
  padding: 12px;
  .top {
    border-bottom: 1px solid #e7eaec;
    padding-bottom: 10px;
    overflow: hidden;
    .title{
      text-align:center;
      line-height: 36px;
    }
  }
  .upload-import{
    display: inline-block;
  }
  .subject {
    overflow: auto;
    padding-left: 171px;
    position: relative;
    .left {
      height: 100%;
      position: absolute;
      width: 161px;
      top: 0;
      left: 0;
      overflow: auto;
      border-right: 1px solid #e7eaec;
      padding: 10px;
      box-sizing: border-box;
      .li {
        font-size: 14px;
        line-height: 28px;
        text-align: center;
        width: 100%;
        margin: 5px 0;
        border-radius: 3px;
        cursor: pointer;
        background: #fff;
        border: 1px solid #dcdfe6;
        color: #606266;
        padding: 5px 0;
        i{
              float: right;
    color: #409eff;
    font-size: 16px;
    line-height: 28px;
    cursor: pointer;
    margin-right: 5px
        }
      }
      .color {
            background-color: #ecf5ff;
            color: #409eff;
            border: 1px solid #d9ecff;
      }
    }
    .body {
      padding: 10px 0;
      box-sizing: border-box;
      .body-top {
        padding-bottom: 10px;
        overflow: auto;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/growthfootprint/growthfootprintevaluationtemplateeidt.vue